const data = [
  {
    path: '/',
    label: 'Hernan Picatto',
    index: true,
  },
  {
    path: '/about',
    label: 'About',
  },
  {
    path: '/resume',
    label: 'Resume',
  },
  {
    path: '/looseleafs',
    label: 'Looseleafs',
  },
  {
    path: '/projects',
    label: 'Projects',
  },
  {
    path: '/stats',
    label: 'Stats',
  },
  {
    path: '/contact',
    label: 'Contact',
  },
];

export default data;
